import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  IconButton,
  Box,
  Tooltip,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import CloseIcon from "@mui/icons-material/Close";
import { toast, ToastContainer } from "react-toastify";

const ShareModal = ({ open, onClose, blogTitle, shareUrl }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    toast.success("Link copied to clipboard!");
  };

  return (
    <>
    <ToastContainer />
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          {blogTitle}
        </Typography>
        <Tooltip title="close">
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              // color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "red" }} />
          </IconButton>
        </Tooltip>
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", pt: 1 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Share this post
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 2 }}>
          <IconButton
            component="a"
            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
              shareUrl
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <TwitterIcon sx={{ color: "#1DA1F2", fontSize: "50px" }} />
          </IconButton>
          <IconButton
            component="a"
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
              shareUrl
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookIcon sx={{ color: "#1877F2", fontSize: "50px" }} />
          </IconButton>
          <IconButton
            component="a"
            href={`https://wa.me/?text=${encodeURIComponent(shareUrl)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsAppIcon sx={{ color: "#25D366", fontSize: "50px" }} />
          </IconButton>
          <IconButton
            component="a"
            href={`mailto:?subject=${encodeURIComponent(
              blogTitle
            )}&body=${encodeURIComponent(shareUrl)}`}
          >
            <EmailIcon sx={{ color: "#7A4CFA", fontSize: "50px" }} />
          </IconButton>
        </Box>

        <Box sx={{ display: "flex", gap: 1 }}>
          <TextField
            fullWidth
            value={shareUrl}
            InputProps={{ readOnly: true }}
          />
          <Tooltip title="Copy to clipboard">
            <IconButton onClick={handleCopy}>
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </DialogContent>
    </Dialog>
    </>
  );
};

export default ShareModal;

// import React from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   IconButton,
//   Button,
//   Box,
//   Tooltip,
//   Typography,
// } from "@mui/material";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
// import FacebookIcon from "@mui/icons-material/Facebook";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// import EmailIcon from "@mui/icons-material/Email";

// const ShareModal = ({ open, onClose, blogTitle, shareUrl }) => {
//   const handleCopy = () => {
//     navigator.clipboard.writeText(shareUrl);
//   };

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
//       <DialogTitle>{blogTitle}</DialogTitle>
//       <DialogActions>
//         <Button onClick={onClose}>Close</Button>
//       </DialogActions>
//       <DialogContent sx={{ textAlign: "center" }}>
//         <Typography variant="body1" sx={{ mb: 2 }}>
//           Share this post
//         </Typography>

//         <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 2 }}>
//           <IconButton
//             component="a"
//             href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
//               shareUrl
//             )}`}
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <TwitterIcon sx={{ color: "#1DA1F2" }} />
//           </IconButton>
//           <IconButton
//             component="a"
//             href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
//               shareUrl
//             )}`}
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <FacebookIcon sx={{ color: "#1877F2" }} />
//           </IconButton>
//           <IconButton
//             component="a"
//             href={`https://wa.me/?text=${encodeURIComponent(shareUrl)}`}
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <WhatsAppIcon sx={{ color: "#25D366" }} />
//           </IconButton>
//           <IconButton
//             component="a"
//             href={`mailto:?subject=${encodeURIComponent(
//               blogTitle
//             )}&body=${encodeURIComponent(shareUrl)}`}
//           >
//             <EmailIcon sx={{ color: "#7A4CFA" }} />
//           </IconButton>
//         </Box>
//         <Box sx={{ display: "flex", gap: 1 }}>
//           <TextField
//             fullWidth
//             value={shareUrl}
//             InputProps={{ readOnly: true }}
//           />
//           <Tooltip title="Copy to clipboard">
//             <IconButton onClick={handleCopy}>
//               <ContentCopyIcon />
//             </IconButton>
//           </Tooltip>
//         </Box>
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default ShareModal;
